import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import CheckboxIcon from '../../../../../../../components/icons/CheckboxIcon';

const propTypes = {
  className: PropTypes.string,
  icon: PropTypes.node.isRequired,
  title: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  active: PropTypes.bool,
};

const SecondaryControlButton = ({
  className,
  icon,
  title,
  onClick,
  active,
}) => {
  const classes = classNames({
    'print-product-configurator-controls-secondary-btn': true,
    'is-active': active,
    [className]: !!className,
  });

  return (
    <a
      href="#"
      className={classes}
      onClick={event => {
        event.preventDefault();
        onClick();
      }}
      title={title}
    >
      {active && (
        <CheckboxIcon
          secondaryColor="#0c84fe"
          className="is-active-checkbox"
          size={20}
        />
      )}
      <div className="print-product-configurator-controls-secondary-btn-icon">
        {icon}
      </div>
      <div className="print-product-configurator-controls-secondary-btn-title">
        {title}
      </div>
    </a>
  );
};

SecondaryControlButton.propTypes = propTypes;

export default SecondaryControlButton;
